import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DatatableServerSideComponent } from './datatable-server-side.component';
@NgModule({
  declarations: [DatatableServerSideComponent],
  imports: [
    CommonModule
  ],
  exports: [DatatableServerSideComponent]
})
export class DatatableServerSideModule { }
